import { AssociatedField, RequiredDetail } from '../requiredDetail.type';
import SingleSelectCheckboxGroup from '../../../components/Form/Checkbox/SingleSelectCheckboxGroup/SingleSelectCheckboxGroup';
import YES_NO_CHECKBOX_VALUES from '../../../ui/shared/form/constants';

const associatedFields: AssociatedField[] = [
  {
    label: 'Activités annulées ?',
    getName: (index) => `codes[${index}].canceledActivities`,
    type: SingleSelectCheckboxGroup,
    list: YES_NO_CHECKBOX_VALUES
  }
];

const canceledActivities: RequiredDetail = {
  associatedFields
};

export default canceledActivities;
